/* =========================
   main.js  — cleaned & fixed
   ========================= */

/* --- Country-specific shipping message ("Auf Lager - in X Tagen...") ---
   Split into a reusable, cached function so it can be re-applied every time a buy-buttons block gets
   swapped in by <product-rerender> after a variant change (see the "product:rerender" listener further
   below). Previously this only ran once inside $(document).ready, so switching variants replaced the
   ".product-shipping-time-message" markup with a freshly-rendered (and freshly re-hidden) copy that
   nothing ever re-revealed — it only came back after a full page reload. The country lookup itself is
   cached so re-applying on every variant change doesn't require a repeat network request. --- */
var __solDetectedCountry = null;
var __solCountryFetchStarted = false;

function solApplyShippingTimeMessage($scope) {
  if (!__solDetectedCountry) return;
  var $root = $scope && $scope.length ? $scope : $(document);

  $root.find(".product-shipping-time-message .product-ship-time-icon").show();
  if (__solDetectedCountry === "DE") {
    $root.find(".product-shipping-time-message .product-ship-time-text-de").show();
  } else if (__solDetectedCountry === "AUT") {
    $root.find(".product-shipping-time-message .product-ship-time-text-aut").show();
  } else {
    $root.find(".product-shipping-time-message .product-ship-time-text-rest").show();
  }
}

function solFetchCountryAndApply() {
  if (__solCountryFetchStarted) return;
  __solCountryFetchStarted = true;

  setTimeout(function () {
    $.get("/browsing_context_suggestions.json", function (res) {
      try {
        __solDetectedCountry = res.detected_values.country.handle;
        $("body").attr("data-country", __solDetectedCountry);
      } catch (e) {}
      solApplyShippingTimeMessage();
    });
  }, 500);
}

/* --- Basic ready bindings --- */
$(document).ready(function () {
  // Robust gift note toggle next to the checkbox
  $(document).on("click", ".cart-gift-product-check", function () {
    var $wrap  = $(this).closest(".cart-glass-packaging");
    var $notes = $wrap.find(".cart-gift-notes");
    if ($(this).is(":checked")) {
      $notes.show();
      $(this).val(1);
    } else {
      $notes.hide();
      $(this).val(0).removeAttr("checked");
    }
  });

  // Glass-check note checkbox value sync
  $(document).on("click", "#cart_glass_check", function () {
    if ($(this).is(":checked")) {
      $(this).val(1);
    } else {
      $(this).val(0).removeAttr("checked");
    }
  });

  solFetchCountryAndApply();
});

/* --- Re-apply the shipping message after every variant-driven buy-buttons refresh ---
   "product:rerender" is dispatched directly on the <form> element (it does not bubble), which is what
   <product-rerender allow-partial-rerender> listens to in order to swap in the new buy-buttons markup.
   We attach our own listener to the same forms so ours runs right after that swap and re-reveals the
   correct delivery-time text using the already-cached country — no extra network round trip. --- */
document.querySelectorAll("form[id]").forEach(function (form) {
  form.addEventListener("product:rerender", function () {
    if (__solDetectedCountry) {
      solApplyShippingTimeMessage($(form));
    } else {
      solFetchCountryAndApply();
    }
  });
});

/* --- Product slideshow tooltip (kept) --- */
$(".product-slideshow__details").on("click", function (e) { e.stopImmediatePropagation(); });
$(".product-slideshow__action").on("click", function () {
  $(".product-slideshow__details").toggleClass("tooltip-active");
});
$(document).on("click", function (e) {
  if (!$(e.target).closest(".product-slideshow__details").length) {
    $(".product-slideshow__details").removeClass("tooltip-active");
  }
});

/* --- Sync variant selection across multiple variant-picker instances for the same product ---
   (e.g. the main product form and the sticky add-to-cart bar). When either one changes, this finds
   the matching option value in every other variant-picker on the page and updates it the same way,
   so sold-out labels, disabled states, and the notify-me message always stay correct and in sync. --- */
document.addEventListener("variant:change", function (event) {
  // IMPORTANT: do NOT use event.detail.formId here. theme.js dispatches this event with
  // detail: { formId: _form.id, ... } — but every form here has a hidden <input name="id"> (the
  // variant id field from buy-buttons.liquid), and in real browsers a same-named form control
  // shadows the form's own .id property. So _form.id (and therefore event.detail.formId) is actually
  // that hidden <input> ELEMENT, not a string — passing it into document.forms[...] never matches
  // anything. theme.js's own code relies on this same quirk elsewhere (_form.id.value = ...), which
  // is how this was spotted. event.target is unaffected by the quirk and is always the real <form>
  // the event was dispatched on, so we use that instead.
  var sourceForm = event.target;
  if (!sourceForm || sourceForm.tagName !== "FORM") return;

  var activeOptionValues = Array.prototype.filter
    .call(sourceForm.elements, function (el) {
      return el.matches && el.matches("input[data-option-position]:checked");
    })
    .map(function (el) {
      return { position: el.getAttribute("data-option-position"), value: el.value };
    });

  if (!activeOptionValues.length) return;

  document.querySelectorAll("variant-picker").forEach(function (picker) {
    var targetFormId = picker.getAttribute("form-id");
    if (!targetFormId) return;

    var targetForm = document.forms[targetFormId];
    if (!targetForm || targetForm === sourceForm) return;

    // IMPORTANT: search inside the <variant-picker> element itself, not the <form>. The radio inputs
    // are associated with their form purely via the HTML "form" attribute (the picker markup lives as
    // a sibling of the actual <form>, not inside it), so they show up in targetForm.elements but are
    // NOT reachable via targetForm.querySelector() — that only walks real DOM descendants. Searching
    // from "picker" instead finds them, since they are genuine descendants of <variant-picker>.
    activeOptionValues.forEach(function (optionValue) {
      var input = picker.querySelector(
        'input[data-option-position="' + optionValue.position + '"][value="' + optionValue.value + '"]'
      );
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });
});

/* --- Gift wrapper add/remove (kept) --- */
$(document).on("click", ".cart-gift-wrapper-packaging #cart-gift-wrapper1", function () {
  var wrapper_id = $(this).attr("wrapper_product");
  if ($(this).is(":checked")) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { quantity: 1, id: wrapper_id },
      dataType: "json"
    });
  } else {
    $.post("/cart/change.js", { quantity: 0, id: wrapper_id });
  }
});

/* --- Sticky add to cart (kept) --- */
function debounce(fn, wait) {
  wait = wait || 500;
  var t;
  return function () {
    clearTimeout(t);
    var args = arguments;
    t = setTimeout(function () { fn.apply(this, args); }, wait);
  };
}
const stickyProductFrom = () => {
  const windowScroll = window.scrollY;
  const scrollTarget = document.querySelector(".ProductMain");
  if (!scrollTarget) return;
  const scrollTargetOffset =
    scrollTarget.getBoundingClientRect().top + scrollTarget.offsetHeight + windowScroll;

  if (windowScroll > scrollTargetOffset) {
    document.querySelector(".ProductStickyCart").classList.add("is-visible");
  } else {
    document.querySelector(".ProductStickyCart").classList.remove("is-visible");
  }
};
if (document.getElementById("ProductStickyCart")) {
  stickyProductFrom();
  window.addEventListener("scroll", stickyProductFrom);
}
$(".ProductForm__Variants .ProductForm__Item").on("click", function () {
  var id = $(this).attr("aria-controls");
  $("#" + id).attr("aria-hidden", false);
  $(".product__OffScreen_overlay").toggleClass("active");
});
$(".Product__OffScreen .Popover__Close").on("click", function () {
  $(this).closest(".Popover").attr("aria-hidden", true);
  $(".product__OffScreen_overlay").toggleClass("active");
});
$(".product__OffScreen_overlay").on("click", function () {
  $(this).closest(".Product__OffScreen").find(".Popover").attr("aria-hidden", true);
  $(this).toggleClass("active");
});

/* ===============================
   Line Item Gift Add / Properties
   =============================== */

let typingTimer;
let doneTypingInterval = 500;

// Disable/Enable checkout helpers
function disableCheckoutButton() {
  $('.cart-drawer__footer button[name="checkout"]').attr("disabled", true);
}
function enableCheckoutButton() {
  $('.cart-drawer__footer button[name="checkout"]').removeAttr("disabled");
  try {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  } catch (e) {}
}

// Save/clear per-line-item properties (string value so iPacky shows the label)
async function updateCartProperties(line_item_key, isChecked, message) {
  message = message || "";
  disableCheckoutButton();

  return fetch("/cart.js")
    .then((r) => r.json())
    .then((cart) => {
      const item = cart.items.find((i) => i.key === line_item_key);
      if (!item) return;

      const properties = {};
      if (isChecked) {
        properties["als_Geschenk_verpacken"] = "🎁 Als Geschenk verpacken";
        if (message.trim() !== "") {
          properties["als_Geschenk_verpacken_message"] = message;
        }
      } else {
        properties["als_Geschenk_verpacken"] = "";
        properties["als_Geschenk_verpacken_message"] = "";
      }

      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: line_item_key,
          quantity: item.quantity,
          properties: properties
        })
      })
        .then((r) => r.json())
        .then(() => {
          if (isChecked) return handleFreeGift();
          return checkAndRemoveFreeGift();
        })
        .finally(enableCheckoutButton);
    })
    .catch(() => enableCheckoutButton());
}

// Checkbox change → persist properties
$(document).on("change", "[data-cart-glass-packaging]", function () {
  const line_item_key = $(this).attr("item_key");
  const isChecked = $(this).is(":checked");
  const message =
    $('.gift-item-cart-note[data-item-product-id="' + $(this).attr("data-item-product-id") + '"]').val() || "";
  updateCartProperties(line_item_key, isChecked, message);
});

// Add free gift if needed
function handleFreeGift() {
  return fetch("/cart.js")
    .then((r) => r.json())
    .then((cart) => {
      const free_item = parseInt($(".cart-drawer__items").attr("free-gift-item"), 10);
      const hasFreeGift = cart.items.some((i) => i.id === free_item);
      if (!hasFreeGift) {
        return addProductWithProperties(free_item, { isgift: true }, 1);
      }
    })
    .catch(console.error);
}

// Remove free gift if no items are gift-wrapped
function checkAndRemoveFreeGift() {
  return fetch("/cart.js")
    .then((r) => r.json())
    .then((cart) => {
      const free_item = parseInt($(document).find(".cart-drawer__items").attr("free-gift-item"), 10);
      const freeGiftItem = cart.items.find((i) => i.id === free_item);
      const anyGiftWrappedItem = cart.items.some((i) => {
        const p = i.properties || {};
        const v = p["als_Geschenk_verpacken"];
        return v === true || v === "true" || (typeof v === "string" && v.trim() !== "");
      });
      if (freeGiftItem && !anyGiftWrappedItem) {
        return removeCartItem(freeGiftItem.key);
      }
    })
    .catch(console.error);
}

// Remove item
function removeCartItem(lineItemKey) {
  return fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: lineItemKey, quantity: 0 })
  })
    .then((r) => r.json())
    .then(() => {
      try {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      } catch (e) {}
    })
    .catch(console.error);
}

// Add product with properties
function addProductWithProperties(variantId, properties, quantity) {
  return fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: quantity, properties: properties })
  }).then((r) => r.json());
}

/* --- Cart note (glass) checkbox mirrors to cart.note (kept) --- */
$(document).on("change", "[data-cart-note]", function () {
  var noteText = $(this).is(":checked") ? "Auf SOL-Glasschatulle verzichten: True" : "";
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ note: noteText })
  }).catch(function(){});
});

/* --- Remove free gift if it is the only item (kept) --- */
document.addEventListener("cart:change", function () {
  var itemsEl = document.querySelector(".cart-drawer__items");
  var free_item = itemsEl ? parseInt(itemsEl.getAttribute("free-gift-item"), 10) : null;
  if (!free_item) return;

  fetch("/cart.js")
    .then((r) => r.json())
    .then((cart) => {
      if (cart.item_count === 1 && cart.items[0].id === free_item) {
        removeCartItem(cart.items[0].key);
      }
    })
    .catch(console.error);
});

/* =========================================
   Checkout: update properties, always navigate
   ========================================= */
$(document)
  .off("click.checkoutHandler", ".cart-drawer__footer [name='checkout']")
  .on("click.checkoutHandler", ".cart-drawer__footer [name='checkout']", function (e) {
    e.preventDefault();

    var updates = [];

    // Only iterate gift checkboxes present in the drawer
    $(".cart-drawer__items [data-cart-glass-packaging]").each(function () {
      var $cb = $(this);
      var key = $cb.attr("item_key");
      if (!key) return;
      var isChecked = $cb.is(":checked");
      var msg =
        $('.gift-item-cart-note[data-item-product-id="' + $cb.attr("data-item-product-id") + '"]').val() || "";
      updates.push(updateCartProperties(key, isChecked, msg));
    });

    var go = function () { window.location.href = "/checkout"; };

    // Navigate as soon as all updates settle (success OR fail)
    Promise.allSettled(updates).then(go).catch(go);

    // Final safety in case something never resolves
    setTimeout(go, 1800);
  });